import PageHeader from 'components/PageHeader.tsx';
import PaddedLayout from 'layout/MainLayout/PaddedLayout.tsx';
import React, { useState } from 'react';
import { ComplianceStatisticsFilter } from 'types/compliance.ts';
import ComplianceDashboard from './ComplianceDashboard.tsx';
import ComplianceTable from './ComplianceTable.tsx';

const CompliancePage: React.FC = () => {
    const [statisticsFilter, setStatisticsFilter] = useState<ComplianceStatisticsFilter | null>(null);

    return (
        <PaddedLayout>
            {/* The new design's lists space their header, cards, toolbar and table with the page column's gap. */}
            <div className="new:flex new:flex-col new:gap-4">
                <PageHeader titleId={'compliance.compliance'} showBreadcrumb hostsList />
                <ComplianceDashboard activeFilter={statisticsFilter} onFilterChange={setStatisticsFilter} />
                <ComplianceTable statisticsFilter={statisticsFilter} />
            </div>
        </PaddedLayout>
    );
};

export default CompliancePage;
